import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ButtonRow from '../../../Elements/ButtonRow';
import ErrorMessage from '../../../Elements/ErrorMessage';
import ServiceFeeItem from '../../../Domain/ServiceFeeItem';
import ServiceFeeService from '../../../Services/ServiceFeeService';
import OtherFeeWindowDescription from './OtherFeeWindowDescription';
import ClientInvoiceEditPanel from '../../Operations/ClientInvoiceAdmin/ClientInvoiceEditPanel';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OtherFeeSearchParams from './OtherFeeSearchParams';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import EditTpClientInvoiceWindowDescription from '../../Operations/TpClientInvoice/EditTpClientInvoiceWindowDescription';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import TpClientInvoiceItem from '../../../Domain/TpClientInvoiceItem';
import contactService from '../../../Services/contactService';
import ClientInvoiceFormOptionsArray from '../../../Enums/ClientInvoiceFormOptionsArray';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import ProjectAssignmentService from '../../../Services/ProjectAssignmentsService';

class OtherFeeAdmin extends React.Component {
  static defaultProps = {
    ActionsDisabled: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      serviceItemList: [],
      selectedItem: null,
      shownPanel: ShownPanelsEnum.None,
      searchItem: { ServiceId: this.props.Service.ServiceId },
      loading: true,
    };
    this.showPanel = this.showPanel.bind(this);
    this.escFunction = this.escFunction.bind(this);
    ServiceFeeItem.editGeneralFunction = this.editGeneralFunction.bind(this);
    ServiceFeeItem.clickOnRemove = this.clickOnRemove.bind(this);
    ServiceFeeItem.GenerateInvoice = this.GenerateInvoice.bind(this);
    ServiceFeeItem.GenerateInvoiceNew = this.GenerateInvoiceNew.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  async clickOnSave() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      searchItem: { ...this.state.searchItem },
    });
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.setState({
        shownPanel: ShownPanelsEnum.None,
        selectedAddress: null,
      });
    }
  }

  editGeneralFunction(id, item) {
    this.setState({
      shownPanel: ShownPanelsEnum.EditItem,
      selectedItem: item,
    });
  }

  GenerateInvoice(id, item) {
    this.setState({
      shownPanel: ShownPanelsEnum.GenerateInvoice,
      selectedItem: item,
    });
  }

  GenerateInvoiceNew(id, item) {
    const clientInvoice = new TpClientInvoiceItem();
    clientInvoice.CaspianClientId = this.props.Service.ClientId;
    clientInvoice.CaspianClientName = this.props.Service.ClientName;
    clientInvoice.OfficeId = this.props.Service.OfficeId;
    clientInvoice.DaysToPay = this.props.Service.ClientDaysToPayCode ? this.props.Service.ClientDaysToPayCode : 30;
    clientInvoice.LatePaymentInterestRate = this.props.Service.ClientInvoiceInterestRate
      ? this.props.Service.ClientInvoiceInterestRate
      : 0;
    if (clientInvoice.OfficeId === 9)
      clientInvoice.FulfillmentDate = dateTimeHelper.addDaysToDate(dateTimeHelper.toYYYYsMMsDD(new Date()), 2);
    clientInvoice.ServiceFeeId = item.ServiceFeeId;

    contactService
      .GetContactListByClientId(this.props.Service.ClientId, true)
      .then((contacts) => {
        clientInvoice.ClientContacts = contacts;

        ProjectAssignmentService.GetProjectAssignmentAdditionalInformation(this.props.Service.ClientId)
          .then((result) => {
            clientInvoice.DefaultReportName = ClientInvoiceFormOptionsArray.find(
              (f) => f.label === result.ciDefaultReportName
            ).value;
            clientInvoice.CurrencyId = result.billingCurId;
            clientInvoice.OfficeName = result.billingOfficeName;

            this.setState({
              selectedItem: clientInvoice,
              shownPanel: ShownPanelsEnum.AddNewInvoice,
            });
          })
          .catch((error) => ErrorMessage.SetErrorMessage('CA134', error));
      })
      .catch((error) => ErrorMessage.SetErrorMessage('CA146', error));
  }

  clickOnRemove(id) {
    ServiceFeeService.RemoveServiceFee(id)
      .then((result) => {
        if (result.error === undefined) {
          ErrorMessage.SetNotification('Removed successfully');

          this.clickOnSave();
        } else {
          ErrorMessage.SetErrorMessage(result.error);
          this.setState({ saving: false });
        }
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('OFA89');
        this.setState({ loading: false });
      });
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  refresh() {
    this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
  }

  renderPanels() {
    const serviceFee = this.state.selectedItem;
    try {
      serviceFee.PurchaseAmtCurId = this.props.Service.OpportunityCurrency;
    } catch {}

    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={
              new ServiceFeeItem({
                serviceId: this.props.Service.ServiceId,
                serviceFeeId: '',
                IsInvoiced: false,
                currency: this.props.Service.OpportunityCurrency,
              })
            }
            clickOnCancel={() => this.clickOnSave()}
            clickOnSave={() => this.clickOnSave()}
            windowDescription={OtherFeeWindowDescription}
            errorCode='OFA133'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={serviceFee}
            clickOnCancel={() => this.clickOnSave()}
            clickOnSave={() => this.clickOnSave()}
            windowDescription={OtherFeeWindowDescription}
            errorCode='OFA143'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.GenerateInvoice,
          <ClientInvoiceEditPanel
            onClose={() => this.clickOnSave()}
            Service={this.props.Service}
            editedItem={serviceFee}
            type='ClientLine_AddToClientInvoice'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewInvoice,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={this.refresh}
            windowDescription={EditTpClientInvoiceWindowDescription}
            errorCode={'OFA176'}
          />
        )}
      </div>
    );
  }

  renderButtonsAndPanels() {
    return (
      <>
        <ButtonRow
          labels={['Create']}
          keys={[ShownPanelsEnum.AddNewItem]}
          icons={['fa-solid fa-plus-circle']}
          roleKeys={['sales_opportunities_button']}
          value={this.state.shownPanel}
          onClick={this.showPanel}
          disabled={[this.getDisabled()]}
          className={'InnerMenuButtonFigmaList'}
          colors={[ButtonColorsEnum.Primary]}
        />
        {this.renderPanels()}
      </>
    );
  }

  getDisabled() {
    return (
      this.props.Service.OpportunityStatusCode.toString() === '11' ||
      this.props.Service.OpportunityStatusCode.toString() === '12'
    );
  }

  handleClickOnStartSearch(searchItem) {
    searchItem.ServiceId = this.props.Service.ServiceId;
    return this.setState({ searchItem });
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={ServiceFeeItem}
          serviceFunction={ServiceFeeService.GetServiceFeeItemList}
          convertDBItemsFunction={ServiceFeeService.ConvertDBItem}
          searchItem={this.state.searchItem}
          searchParamsType={OtherFeeSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={(searchItem) => this.handleClickOnStartSearch(searchItem)}
          enableUrlPush={false}
          errorCode='OFA220'
          useClickOnClearAll={true}
        />
      </div>
    );
  }
}

export default OtherFeeAdmin;
